import { defaults } from 'lodash';
import {
  FORMULAS_DEFAULT_WIDTH,
  FORMULAS_DEFAULT_HEIGHT,
} from '../../iframe/additional-apps.utils';
import { FrameItem } from '../../../../models/session';
import { BoardItemConfig, CreationContext } from './board-item-configurations';

export class FormulaConfigurations extends BoardItemConfig {
  equation: string;
  fontSize: number;
  fontColor: string;
  backgroundColor: string;

  static defaultBoardItemConfigurations: Partial<BoardItemConfig> = {
    width: FORMULAS_DEFAULT_WIDTH,
    height: FORMULAS_DEFAULT_HEIGHT,
  };

  static defaultConfigs = {
    equation: '$$$$',
    fontSize: 24,
    fontColor: '#333333',
    backgroundColor: 'transparent',
  };

  constructor(
    configurations: Partial<FormulaConfigurations> & Partial<BoardItemConfig>,
    globalCreationParams: CreationContext,
  ) {
    super(
      {
        ...FormulaConfigurations.defaultBoardItemConfigurations,
        ...configurations,
      },
      globalCreationParams,
    );

    const formulaConfigurations = defaults(configurations, FormulaConfigurations.defaultConfigs);

    this.equation = formulaConfigurations.equation;
    this.fontSize = formulaConfigurations.fontSize;
    this.fontColor = formulaConfigurations.fontColor;
    this.backgroundColor = formulaConfigurations.backgroundColor;
  }

  static fromYCanvasItemObject(
    frameItem: FrameItem,
    globalCreationsParams: CreationContext,
  ): FormulaConfigurations {
    const configurations = BoardItemConfig.fromYCanvasItemObject(
      frameItem,
      globalCreationsParams,
      FormulaConfigurations.defaultBoardItemConfigurations,
    );

    return new FormulaConfigurations(
      {
        ...configurations,
        equation:
          frameItem.equation_state?.equation_data ?? FormulaConfigurations.defaultConfigs.equation,
        fontSize: +(
          frameItem.position?.get('font:size') ?? FormulaConfigurations.defaultConfigs.fontSize
        ),
        fontColor:
          frameItem.position?.get('font:color') ?? FormulaConfigurations.defaultConfigs.fontColor,
        backgroundColor:
          frameItem.position?.get('background:color') ??
          FormulaConfigurations.defaultConfigs.backgroundColor,
      },
      globalCreationsParams,
    );
  }
}
